<template lang="pug">
.UiNotificaciones.EspacioSeguro(:class="{ oscuro: !unref(TemaOscuroAPI.claro) }")
  ClientOnly
    transition
      .zonaNotificaciones.colapsable.ffcn.aife(v-if="!lodash.isEmpty(notificacionesAbiertas)")
        TransitionGroup
          UiNotificacion(v-for="(notificacion, id) in notificacionesAbiertas" :key="id" :notificacion="notificacion")
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted } from 'vue'
import { NotificacionesEnApp } from '@base/composables/notificaciones'
import { consolo } from '@base/composables/consolo'

const notificacionesAbiertas = computed(() => {
  const notificaciones = unref(NotificacionesEnApp.lista)
  return lodash.pickBy(notificaciones, n => !n.cerrada)
})

// Seccion para desarrollo y pruebas
const duracionNotificacionXTeclado = 155000
function teclasGenerador(event: KeyboardEvent) {
  if (event.code === 'KeyK' && event.altKey) {
    NotificacionesEnApp.info({
      titulo: 'Información',
      texto: 'Has pulsado las teclas Alt + K',
      codigo: 'infoPorTeclas',
      duracionSegundos: duracionNotificacionXTeclado
    })
  }
  if (event.code === 'KeyS' && event.altKey) {
    NotificacionesEnApp.exito({
      titulo: 'Éxito',
      texto: 'Has pulsado las teclas Alt + S',
      codigo: 'exitoPorTeclas',
      duracionSegundos: duracionNotificacionXTeclado
    })
  }
  if (event.code === 'KeyW' && event.altKey) {
    NotificacionesEnApp.atencion({
      titulo: 'Atencion',
      texto: 'Has pulsado las teclas Alt + W',
      codigo: 'atencionPorTeclas',
      duracionSegundos: duracionNotificacionXTeclado
    })
  }
  if (event.code === 'KeyP' && event.altKey) {
    NotificacionesEnApp.error({
      titulo: 'Error',
      texto: 'Has pulsado las teclas Alt + P',
      codigo: 'errorPorTeclas',
      duracionSegundos: duracionNotificacionXTeclado
    })
  }
}

// Agregar un listener para las teclas
onMounted(() => {
  window.addEventListener('keydown', teclasGenerador)
  
})
// Quitarlo al desmontar
onUnmounted(() => {
  window.removeEventListener('keydown', teclasGenerador)
})
</script>

<style lang="sass" scoped>
@forward '@base/sass/comun'
@use '@base/sass/comun'

.UiNotificaciones
  pointer-events: none
  position: fixed
  z-index: 47
  top: 0
  right: 0
  margin-top: var(--barraSuperiorAltura)
  line-height: 1
  // border: 1px solid red
  max-height: 100dvh
  +comun.movil
    left: 0
  +comun.tablet
    left: 0
  .zonaNotificaciones
    // pointer-events: none
    position: relative
    padding: var(--ud)
    
    +comun.movil
      border-bottom-left-radius: comun.$radio
      border-bottom-right-radius: comun.$radio

      width: 100%
      left: 0
      right: 0
      backdrop-filter: blur(.2rem)
      padding-bottom: 2rem
      mask-image: linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0, 1) 1rem)
      &::before
        border-bottom-left-radius: comun.$radio
        border-bottom-right-radius: comun.$radio
        content: ''
        display: block
        +comun.maximizar
        background-color: var(--bodyFondo)
        opacity: .1
      .notificacion
        width: 100%
  .notificacion
    pointer-events: initial
    user-select: none
  .notificacion + .notificacion
    margin-top: .5rem
</style>
